import { HTMLAudioMedia } from './HTMLAudioMedia';
import { HTMLAudioInstance } from './HTMLAudioInstance';
import { HTMLAudioContext } from './HTMLAudioContext';

/**
 * Classes supporting non-WebAudio based browsers.
 * @namespace htmlaudio
 */
export default {
    HTMLAudioContext,
    HTMLAudioMedia,
    HTMLAudioInstance,
};
